import Page from 'pages/Page';
import SliderInterface from 'components/Slider/interfaces/SliderInterface';
import SliderTrustpilot from 'components/Slider/SliderTrustpilot/SliderTrustpilot';
import ConfirmNewsletterChunk from '../../modules/InitChunks/ConfirmNewsletterChunk/ConfirmNewsletterChunk';
import NewsletterChunk from '../../modules/InitChunks/NewsletterChunk/NewsletterChunk';

export default class HomePages extends Page {
  constructor() {
    super();
    const sliderTrustpilot: SliderInterface = {};

    window.addEventListener('load', () => {
      // Add Newsletter in page
      new NewsletterChunk();

      // Confirm Newsletter
      HomePages.confirmRegister();

      new SliderTrustpilot(sliderTrustpilot);
    });
  }

  /*
   * Popin confirm register to Newsletter
   * */
  private static confirmRegister(): void {
    const newsletterConfirm: HTMLInputElement = document.querySelector(
      '.c-newsletter__confirmation'
    );

    if (newsletterConfirm) {
      new ConfirmNewsletterChunk();
    }
  }
}
